<template>
  <div class="myOrders">

      <el-row class="static" :gutter="20">
          <el-col :span="6">
            <el-card shadow="hover">
              <el-statistic  title="已提交工单">
                <template slot="formatter"> {{ ordersData.submit_total }} </template>
              </el-statistic>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover">
              <el-statistic  title="当前未受理工单">
                <template slot="formatter"> {{ ordersData.wait_accept_total }} </template>
              </el-statistic>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover">
              <el-statistic  title="已受理工单">
                <template slot="formatter"> {{ ordersData.accepted_total }} </template>
              </el-statistic>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card shadow="hover">
              <el-statistic  title="已完结工单">
                <template slot="formatter"> {{ ordersData.close_total }} </template>
              </el-statistic>
            </el-card>
          </el-col>
      </el-row>


      <el-row class="formSearch">
        <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <span>工单搜索</span>       
            </div>
            <div class="textItem">
              <el-form ref="formData" label-position="left" :inline="true" :model="formData"  size="small" label-width="85px">
                  <el-form-item label="工单查询" prop="sn">
                    <el-input clearable v-model="formData.sn" placeholder="工单号/型号/标题"></el-input>
                  </el-form-item>
                  <el-form-item label="产品型号" prop="goods_model">
                    <el-select
                      v-model="formData.goods_model"
                      clearable
                      filterable
                      remote
                      reserve-keyword
                      placeholder="请输入型号关键词"
                      :remote-method="remoteMethod"
                      :loading="modelLoading">
                      <el-option
                        v-for="item in modelOptions"
                        :key="item.id"
                        :label="item.model"
                        :value="item.model">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="工单类型：" prop="type">
                    <el-select v-model="formData.type" clearable placeholder="请选择">
                      <el-option v-for="item in selectType" :key="item.value" :label="item.text " :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="所属部门：" prop="depart_id">
                    <el-select clearable v-model="formData.depart_id">
                      <el-option v-for="item in part" :label="item.name" :value="item.id" :key="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="工单状态："  prop="status">
                    <el-select v-model="formData.status" clearable placeholder="请选择活动区域">
                      <el-option v-for="item in ordersStstus" :key="item.value" :label="item.text " :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="按发起人" prop="publish_person_name">
                    <el-input clearable v-model="formData.publish_person_name" placeholder="请输入发起人姓名"></el-input>
                  </el-form-item>
                  <el-form-item label="创建时间" prop="time">
                    <el-date-picker
                      v-model="formData.time"
                      value-format="timestamp"
                      format="yyyy 年 MM 月 dd 日"
                      unlink-panels
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="searchEvent">查询</el-button>
                    <el-button @click="resetForm('formData')">重置</el-button>
                    <el-button type="primary" @click="reOrders">发布工单</el-button>
                  </el-form-item>
              </el-form>
            </div>
            <div class="formTable">
                <el-table
                  border
                  :data="tableData"
                  stripe
                  style="width: 100%"
                  @cell-click="cellClick">
                      <el-table-column
                        prop="sn"
                        label="工单号"
                        class-name="snLabel"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="title"
                        label="标题"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="goods_model"
                        label="产品型号"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="type"
                        label="工单类型"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="goods_category_name"
                        label="所属部门"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="create_time"
                        label="更新时间"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="status"
                        label="状态"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="reminder_count"
                        label="催单次数"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="create_person"
                        label="工单发起人"
                        >
                      </el-table-column>
                      <el-table-column
                        prop="accept_person"
                        label="接单人"
                        >
                      </el-table-column>
                    <el-table-column
                      fixed="right"
                      label="操作"
                      >
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          size="small"
                          v-if="scope.row.status == '已退回'?false:(scope.row.status == '已完结'?false:true)">
                          <el-popconfirm confirm-button-text='是的' cancel-button-text='取消' icon="el-icon-info"
                              icon-color="#66b1ff" title="您确认催单吗？" @confirm="reminders(scope.row)">
                              <el-button slot="reference" type="text" size="small">催单</el-button>
                          </el-popconfirm>
                        </el-button>
                        <el-button
                          type="text"
                          size="small">
                            <el-popconfirm confirm-button-text='是的' cancel-button-text='取消' icon="el-icon-info"
                                icon-color="#66b1ff" title="您确认删除该工单么？" @confirm="confirmEvent(scope.row)">
                                <el-button slot="reference" type="text" size="small">删除</el-button>
                            </el-popconfirm>
                        </el-button>
                      </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pages">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                @current-change="currentClick">
              </el-pagination>
            </div>
        </el-card>
      </el-row>



  </div>
</template>

<script>
import {getOrderType,getOrderCounterAll,getOrderTable,reminder,getOrderSearch,getOrstatus,orderRemove,departTable,modelSelect } from '../../utils/api'
export default {
props: {},
data() {
  return {
    page:1,
    total:0,
    pageSize:10,
    ordersData:{
      submit_total:'', //已提交工单总数
      wait_accept_total:'', // 未受理工单总数
      accepted_total:'', //已受理工单总数
      close_total:'' //已完成工单总数
    },
    formData:{
        sn:'',
        type:'',
        time:'',
        status:'',
        publish_person_name:'',
        depart_id:'',
    },
    tableData:[],
    selectType:[],
    ordersStstus:[],
    part:[],
    modelLoading:false,
    modelOptions:[]
  };
},
methods: {
  onSubmit(){
    console.log('搜索');
  },
  //确认删除工单
  confirmEvent(row){
    console.log(row,'row');
    var that = this
    var param = {
      order_id:row.id
    }
    orderRemove(param)
    .then(res=>{
      console.log(res,'删除操作');
      if(res.message.status == 'success'){
          that.$message.success('删除成功')
          that.getOrderTables()
          that.getCounter()
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  //工单统计
  getCounter(){
    var that = this
    getOrderCounterAll()
    .then(res=>{
      that.ordersData = res.data
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  //获取工单类型
  getType(){
    var that = this
    getOrderType()
    .then(res=>{
      if(res.message.status == 'success'){
        that.selectType = []
        res.data.forEach(item=>{
          that.selectType.push({
            text:item.type,
            value:item.type
          })
        })
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  //工单查询
  searchEvent(){
    var that = this
    var times = that.formData.time;
    if(times === ''){
      times = null
    }
    if(Array.isArray(times) && times[0] === ''){
      times = null
    }
    var params = {
        page : that.page,
        pagesize:that.pageSize,
        sn:that.formData.sn,
        goods_model:that.formData.goods_model,
        type:that.formData.type,
        create_person:that.formData.publish_person_name,
        begin_time:times == null?'':times[0]/1000,
        end_time:times ==null?'':times[1]/1000,
        status:that.formData.status,
        depart_id:that.formData.depart_id
    }
    getOrderSearch(params)
    .then(res=>{
      console.log(res,'工单查询');
      if(res.message.status == 'success'){
        that.tableData = res.data
        that.getStatus(that.tableData)
        that.total = res.total
      }else{
        that.tableData = []
        that.total = 0
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  //重置
  resetForm(formName){
    console.log('1111111111');
    this.$refs[formName].resetFields();
  },
  //当前页
  currentClick(e){
    console.log(e,'当前页');
    var that = this
    that.page = e
    if(that.formData.sn !== '' || that.formData.type !== '' || (that.formData.time !== null && that.formData.time !== '') || that.formData.status !== ''){
          that.searchEvent()
     }else{
          that.getOrderTables()
     }
    // that.getOrderTables()
  },
  cellClick(row, column, cell, event){
    if(column.label == '工单号'){
        this.$router.push('/orderDetail/orderDetail?jumpId='+(row.id))
    }
  },
  reOrders(){
    this.$router.push({name:'reOrders'})
  },
  //获取工单列表
  getOrderTables(){
    var that = this
    var params = {
      page:that.page,
      pagesize:that.pageSize
    }
    getOrderTable(params)
    .then(res=>{
      console.log(res,'工单列表');
      if(res.message.status == 'success'){
        that.tableData = res.data
        that.getStatus(that.tableData)
        that.total = res.total
      }else{
        that.tableData = []
        that.total = 0
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  //催单
  reminders(row){
    var params = {
      order_id:row.id
    }
    reminder(params)
    .then(res=>{
      console.log(res,'催单ssss');
      if(res.message.status == 'success'){
        this.$message.success('催单成功')
        this.tableData.forEach(item=>{
            if(item.id == row.id){
                item.reminder_count = res.data.reminder_count
            }
          })
      }else{
        this.$message.error(res.message.text)
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  //获取工单状态列表
  getOrderStatus(){
    var that = this
    getOrstatus()
    .then(res=>{
      if(res.message.status == 'success'){
          that.ordersStstus = res.data.list
          that.ordersStstus.forEach(item=>{
            item['text'] = item.title
          })
      }else{
        that.$message.error(res.message.text)
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  //获取顶级分类
  getDepartTable(){
    departTable()
    .then(res=>{
      console.log(res,'获取顶级分类');
      if(res.message.status == 'success'){
        this.part = res.data
      }else{
        this.$message.error(res.message.text)
      }
    })
    .catch(err=>{
      console.log(err,'err');
    })
  },
  //型号模糊查询触发
  remoteMethod(value){
    console.log('促发了');
    this.modelOptions = []
    if(value !== ''){
      this.modelLoading = true;
      var params = {
        model:value
      }
      modelSelect(params)
      .then(res=>{
        console.log(res,'模糊查询结果');
        if(res.message.status == 'success'){
          this.modelOptions = res.data
          this.modelLoading = false
        }else{
          this.modelLoading = false
          this.$message.error(res.message.text)
        }
      })
      .catch(err=>{
        this.$message.error(err)
        this.modelLoading = false
        console.log(err);
      })
    }else{
      this.modelOptions = []
    }
  },



},
created() {},
mounted() {
  this.getType()
  this.getOrderStatus()
  this.getDepartTable()
},
activated(){
  this.getCounter()
  this.getOrderTables()
  this.searchEvent()
}
};
</script>
<style lang="scss" scoped>
.row-bg{
background: #e3e2e2;
line-height: 50px;
padding: 0 20px;
}

.formSearch{
background: #ffffff;
margin-top: 10px;
h3{
  padding-top: 10px;
  color: #333;
  font-size: 16px;
}
}

.pages{
text-align: right;
margin-top: 20px;
}

.formTable{
  ::v-deep .snLabel{
    color: #409EFF;
    margin: 10px 0;
    div:hover{
      border-bottom: 2px solid #65afec;
      cursor: pointer;
    }
  }

  ::v-deep .is-leaf{
    color: #666 !important;
    div:hover{
      border-bottom: none;
    }
  }
}
</style>